module.exports = __webpack_public_path__ + "static/media/approach-render.d1148259.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/approach-render.jpg
// module id = 140
// module chunks = 0